(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FAQSection {
    constructor(section) {
      this.section = section;
      this.searchInput = section.querySelector('[data-faq-search]');
      this.faqItems = section.querySelectorAll('[data-faq-item]');
      this.categoryButtons = section.querySelectorAll('[data-category]');
      this.noResults = section.querySelector('[data-faq-no-results]');
      this.currentCategory = 'all';
      this.currentSearch = '';

      this.init();
    }

    init() {
      // Ensure all items are visible initially
      this.faqItems.forEach((item) => {
        item.classList.remove('t4s-hidden');
      });

      // Search functionality
      if (this.searchInput) {
        this.searchInput.addEventListener(
          'input',
          this.handleSearch.bind(this)
        );
      }

      // Category filtering
      this.categoryButtons.forEach((btn) => {
        btn.addEventListener('click', this.handleCategoryClick.bind(this));
      });

      // FAQ item toggle - prevent answer clicks from causing issues
      this.faqItems.forEach((item) => {
        const question = item.querySelector('[data-faq-question]');
        const answer = item.querySelector('[data-faq-content]');

        if (question) {
          question.addEventListener('click', this.handleToggle.bind(this));
        }

        // Prevent clicks on answer from affecting toggle
        if (answer) {
          answer.addEventListener('click', (e) => {
            e.stopPropagation();
          });
        }
      });
    }

    handleSearch(e) {
      this.currentSearch = e.target.value.toLowerCase().trim();
      this.filterFAQs();
    }

    handleCategoryClick(e) {
      const btn = e.currentTarget;
      const category = btn.dataset.category;

      // Update active state
      this.categoryButtons.forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');

      this.currentCategory = category;
      this.filterFAQs();
    }

    handleToggle(e) {
      e.preventDefault();
      e.stopPropagation();

      const item = e.currentTarget.closest('[data-faq-item]');
      const content = item.querySelector('[data-faq-content]');

      if (!item || !content) return;

      // Don't allow toggle if item is hidden by filter/search
      if (item.classList.contains('t4s-hidden')) return;

      // Close other active items (but don't change their hidden state)
      const isActive = item.classList.contains('t4s-active');

      this.faqItems.forEach((i) => {
        if (i !== item && i.classList.contains('t4s-active')) {
          i.classList.remove('t4s-active');
        }
      });

      // Toggle current item
      if (!isActive) {
        item.classList.add('t4s-active');
      } else {
        item.classList.remove('t4s-active');
      }
    }

    filterFAQs() {
      let visibleCount = 0;

      this.faqItems.forEach((item) => {
        const itemCategory = item.dataset.category || 'general';
        const question = item.dataset.question || '';
        const answer =
          item.querySelector('[data-faq-content]')?.textContent.toLowerCase() ||
          '';

        // Check category match
        const categoryMatch =
          this.currentCategory === 'all' ||
          itemCategory === this.currentCategory;

        // Check search match
        const searchMatch =
          this.currentSearch === '' ||
          question.includes(this.currentSearch) ||
          answer.includes(this.currentSearch);

        if (categoryMatch && searchMatch) {
          // Show item - only use class, no inline styles
          item.classList.remove('t4s-hidden');
          visibleCount++;
        } else {
          // Hide item - only use class
          item.classList.add('t4s-hidden');
        }
      });

      // Show/hide no results message
      if (this.noResults) {
        this.noResults.style.display = visibleCount === 0 ? 'block' : 'none';
      }
    }
  }

  // Initialize FAQ sections
  document.querySelectorAll('.t4s-faq-section').forEach((section) => {
    new FAQSection(section);
  });

  } catch(e) { console.error(e); }
})();
})();
